import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DAY = 24 * 3600 * 1000;

export const isUrgentTicket = (r) => {
  const now = Date.now();
  const next = (r.sessions || []).find((s) => new Date(s.starts_at).getTime() > now);
  return !!next && next.state === "sin_confirmar" && new Date(next.starts_at).getTime() - now < DAY;
};

export function useUrgentTickets(enabled, refreshKey) {
  const [count, setCount] = useState(0);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const on = () => setTick((t) => t + 1);
    window.addEventListener("tickets-changed", on);
    return () => window.removeEventListener("tickets-changed", on);
  }, []);
  useEffect(() => {
    if (!enabled) return setCount(0);
    api.get("/reservations/mine").then((r) => setCount((r.data.active || []).filter(isUrgentTicket).length)).catch(() => {});
  }, [enabled, refreshKey, tick]);
  return count;
}

export const UrgentDot = ({ n, testId, className = "" }) => (n > 0 ? (
  <span className={`min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold grid place-items-center ring-2 ring-background ${className}`}
    data-testid={testId} aria-label={`${n} taller(es) por confirmar`}>{n}</span>
) : null);
